"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var AndroidDownload = function AndroidDownload(_a) {
  var _a$height = _a.height,
      height = _a$height === void 0 ? "auto" : _a$height,
      _a$width = _a.width,
      width = _a$width === void 0 ? "100%" : _a$width,
      rest = __rest(_a, ["height", "width"]);

  return react_1["default"].createElement("div", Object.assign({
    style: {
      maxWidth: "200px",
      width: width,
      height: height
    }
  }, rest), react_1["default"].createElement(common_1["default"], {
    "data-icon": "android-download",
    viewBox: "0 0 180 53"
  }, react_1["default"].createElement("g", {
    fill: "currentColor"
  }, react_1["default"].createElement("path", {
    d: "m12.6 27.4v9.8c0 .8.5 1.5 1.2 1.5h3.2v5.7c0 1.4 1.2 2.6 2.6 2.6s2.6-1.2 2.6-2.6v-5.7h5.3v5.7c0 .8.4 1.5 1 2 .4.4 1 .6 1.6.6h.1c1.4 0 2.6-1.2 2.6-2.6v-5.7h3c.8 0 1.2-.8 1.2-1.5v-18.2h-24.4zm4.8-1h1.1c.1-.4.2-.8.3-1.2l-1-.6 1.1-1.8 1 .6c.3-.3.5-.6.8-.8l-.6-1 1.8-1.1.6 1c.4-.1.8-.2 1.2-.3v-1.1h2.1v1.1c.4.1.8.2 1.2.3l.6-1 1.8 1.1-.6 1c.3.3.6.5.8.8l1-.6 1.1 1.8-1 .6c.1.4.2.8.3 1.2h1.1v2.1h-1.1c-.1.4-.2.8-.3 1.2l1 .6-1.1 1.8-1-.6c-.3.3-.5.6-.8.8l.6 1-1.8 1.1-.6-1c-.4.1-.8.2-1.2.3v1.1h-2.1v-1.1c-.4-.1-.8-.2-1.2-.3l-.6 1-1.8-1.1.6-1c-.3-.3-.6-.5-.8-.8l-1 .6-1.1-1.8 1-.6c-.1-.4-.2-.8-.3-1.2h-1.1z"
  }), react_1["default"].createElement("path", {
    d: "m41.4 17.3c-1.4 0-2.6 1.2-2.6 2.6v10.5c0 1.4 1.2 2.6 2.6 2.6s2.6-1.2 2.6-2.6v-10.5c0-1.4-1.2-2.6-2.6-2.6z"
  }), react_1["default"].createElement("path", {
    d: "m8.3 17.3c-1.4 0-2.6 1.2-2.6 2.6v10.5c0 1.4 1.2 2.6 2.6 2.6s2.6-1.2 2.6-2.6v-10.5c0-1.4-1.2-2.6-2.6-2.6z"
  }), react_1["default"].createElement("path", {
    d: "m30.8 7.8 2-2.4c0-.1 0-.2-.1-.3s-.3-.1-.3 0l-2.1 2.5c-1.5-.6-3.3-1-5.5-1s-4.1.3-5.5.9l-2.1-2.4c0-.1-.2 0-.3 0-.1.1-.2.2-.1.3l2 2.4c-5.3 2.3-6 7.9-6.1 9.5h24.3c-.1-1.6-.9-7.1-6.2-9.5zm-11.3 5.4c-.8 0-1.5-.6-1.5-1.4s.7-1.4 1.5-1.4 1.5.6 1.5 1.4-.7 1.4-1.5 1.4zm10.7 0c-.8 0-1.5-.6-1.5-1.4s.7-1.4 1.5-1.4 1.5.6 1.5 1.4-.7 1.4-1.5 1.4z"
  }), react_1["default"].createElement("path", {
    d: "m28.1 30-2.2-2.2-1.1-1.1-.2-.2c.3-.8.1-1.6-.5-2.2-.7-.7-1.6-.8-2.4-.4l1.4 1.4-1 1-1.4-1.4c-.4.8-.2 1.8.4 2.4s1.5.8 2.3.5l.3.3-1.9 1.9c-.1.1-.1.4 0 .5l.8.8c.1.1.4.1.5 0l1.8-2.1 2.1 2.1c.1.1.3.1.5 0l.8-.8c-.1-.2-.1-.4-.2-.5z"
  }), react_1["default"].createElement("path", {
    d: "m29.2 26.7-.6-.6h-.1l-.1.1-.4-.4s0-.2-.1-.3c-.1-.2-.3-.4-.4-.5s-.6-.6-1.3-1c-.7-.3-1.1-.5-1.7-.5v.5s.5.3.8.5.3 1.1.3 1.1l-.5.5 1 1 .6-.7c.2-.1.4-.1.6 0l.3.2-.2.2v.1l.6.6h.1l1-1c.2.3.2.2.1.2z"
  }), react_1["default"].createElement("path", {
    d: "m51.6 16.8v-11h3.3c1 0 1.8.2 2.6.7.8.4 1.3 1 1.8 1.8.4.8.6 1.7.6 2.7v.6c0 1-.2 2-.6 2.8s-1 1.4-1.8 1.8-1.7.6-2.6.6zm1.9-9.5v7.9h1.2c1 0 1.8-.3 2.3-.9s.8-1.5.8-2.7v-.6c0-1.2-.3-2.1-.8-2.7s-1.3-.9-2.3-.9z"
  }), react_1["default"].createElement("path", {
    d: "m61.2 12.6c0-.8.2-1.5.5-2.2.3-.6.8-1.1 1.3-1.4.6-.3 1.2-.5 2-.5 1.1 0 2 .4 2.7 1.1s1.1 1.7 1.1 2.8v.4c0 .8-.2 1.5-.5 2.2-.3.6-.8 1.1-1.3 1.5s-1.2.5-2 .5c-1.2 0-2.1-.4-2.8-1.2-.6-.8-1-1.8-1-3.2zm1.9.2c0 .8.2 1.5.5 2s.8.7 1.5.7c.6 0 1.1-.2 1.4-.7s.5-1.2.5-2.1c0-.8-.2-1.5-.5-2-.4-.5-.8-.7-1.4-.7s-1.1.2-1.4.7c-.5.4-.6 1.1-.6 2.1z"
  }), react_1["default"].createElement("path", {
    d: "m77.6 14.3 1.3-5.7h1.8l-2.2 8.2h-1.5l-1.8-5.6-1.7 5.6h-1.5l-2.2-8.2h1.8l1.3 5.6 1.7-5.6h1.4z"
  }), react_1["default"].createElement("path", {
    d: "m83.6 8.6.1.9c.6-.7 1.4-1.1 2.4-1.1 1.7 0 2.6 1 2.6 2.9v5.4h-1.8v-5.3c0-.5-.1-.9-.3-1.2-.2-.2-.6-.4-1.1-.4-.7 0-1.3.3-1.7 1v5.8h-1.8v-8z"
  }), react_1["default"].createElement("path", {
    d: "m92.5 16.8h-1.8v-11.6h1.8z"
  }), react_1["default"].createElement("path", {
    d: "m94.1 12.6c0-.8.2-1.5.5-2.2.3-.6.8-1.1 1.4-1.4s1.2-.5 2-.5c1.1 0 2 .4 2.7 1.1s1.1 1.7 1.1 2.8v.4c0 .8-.2 1.5-.5 2.2-.3.6-.8 1.1-1.3 1.5-.6.3-1.2.5-2 .5-1.2 0-2.1-.4-2.8-1.2s-1.1-1.8-1.1-3.2zm1.9.2c0 .8.2 1.5.5 2s.8.7 1.5.7c.6 0 1.1-.2 1.4-.7s.5-1.2.5-2.1c0-.8-.2-1.5-.5-2s-.8-.7-1.4-.7-1.1.2-1.4.7c-.4.4-.6 1.1-.6 2.1z"
  }), react_1["default"].createElement("path", {
    d: "m108.2 16.8c-.1-.2-.2-.4-.2-.8-.6.6-1.3.9-2.1.9s-1.5-.2-2-.7-.8-1-.8-1.7c0-.9.3-1.5 1-2 .6-.5 1.6-.7 2.8-.7h1.1v-.5c0-.4-.1-.8-.4-1-.2-.3-.6-.4-1.1-.4-.4 0-.8.1-1 .3-.3.2-.4.5-.4.8h-1.8c0-.4.1-.9.4-1.3s.7-.7 1.2-.9 1.1-.3 1.7-.3c1 0 1.7.2 2.3.7s.9 1.2.9 2v3.7c0 .7.1 1.3.3 1.8v.1zm-2-1.3c.4 0 .7-.1 1-.3s.6-.4.7-.7v-1.5h-1c-.7 0-1.2.1-1.5.4-.3.2-.5.6-.5 1s.1.6.4.8c.2.2.5.3.9.3z"
  }), react_1["default"].createElement("path", {
    d: "m111.3 12.6c0-1.3.3-2.3.9-3s1.4-1.1 2.4-1.1c.9 0 1.6.3 2.1.9v-4.2h1.8v11.6h-1.7l-.1-.8c-.6.7-1.3 1-2.2 1-1 0-1.7-.4-2.3-1.2s-.9-1.8-.9-3.2zm1.9.2c0 .8.2 1.5.5 1.9s.8.7 1.4.7c.8 0 1.3-.3 1.6-1v-3.4c-.3-.7-.9-1-1.6-1-.6 0-1.1.2-1.4.7s-.5 1.2-.5 2.1z"
  }), react_1["default"].createElement("path", {
    d: "m60.1 35.3h-5.8l-1.2 3.5h-2.7l5.7-15.1h2.4l5.7 15.1h-2.7zm-5.1-2.1h4.4l-2.2-6.3z"
  }), react_1["default"].createElement("path", {
    d: "m67.4 27.6.1 1.3c.8-1 1.9-1.5 3.3-1.5 2.3 0 3.5 1.3 3.6 4v7.4h-2.5v-7.3c0-.7-.2-1.2-.5-1.6-.3-.3-.8-.5-1.5-.5-1 0-1.8.5-2.3 1.4v8h-2.5v-11.2z"
  }), react_1["default"].createElement("path", {
    d: "m76.4 33.1c0-1.7.4-3.1 1.2-4.2.8-1 1.9-1.6 3.2-1.6 1.2 0 2.1.4 2.9 1.2v-5.7h2.5v15.9h-2.2l-.1-1.2c-.8.9-1.8 1.4-3 1.4-1.3 0-2.4-.5-3.2-1.6-.9-.9-1.3-2.4-1.3-4.2zm2.5.2c0 1.1.2 2 .7 2.7.4.6 1.1 1 1.9 1 1 0 1.8-.5 2.3-1.4v-4.8c-.5-.9-1.2-1.3-2.2-1.3-.8 0-1.4.3-1.9 1-.5.6-.8 1.5-.8 2.8z"
  }), react_1["default"].createElement("path", {
    d: "m94.8 29.9c-.3-.1-.7-.1-1-.1-1.2 0-1.9.4-2.3 1.3v7.7h-2.5v-11.2h2.4l.1 1.3c.6-1 1.5-1.5 2.5-1.5.4 0 .7 0 .9.1z"
  }), react_1["default"].createElement("path", {
    d: "m95.5 33.1c0-1.1.2-2.1.7-3 .4-.9 1-1.6 1.8-2 .8-.5 1.7-.7 2.7-.7 1.5 0 2.7.5 3.7 1.5.9 1 1.5 2.3 1.5 3.9v.6c0 1.1-.2 2.1-.6 3s-1 1.5-1.8 2-1.7.7-2.7.7c-1.6 0-2.8-.5-3.8-1.6s-1.4-2.5-1.4-4.2zm2.5.2c0 1.2.2 2.1.7 2.7s1.1 1 2 1 1.5-.3 2-1 .7-1.6.7-2.9c0-1.1-.2-2-.7-2.7s-1.1-1-2-1c-.8 0-1.5.3-2 1-.4.6-.7 1.6-.7 2.9z"
  }), react_1["default"].createElement("path", {
    d: "m108.1 24.7c0-.4.1-.7.4-1 .2-.3.6-.4 1.1-.4s.8.1 1.1.4c.2.3.4.6.4 1s-.1.7-.4.9c-.2.3-.6.4-1.1.4s-.8-.1-1.1-.4c-.3-.2-.4-.5-.4-.9zm2.6 14.1h-2.5v-11.2h2.5z"
  }), react_1["default"].createElement("path", {
    d: "m113 33.1c0-1.7.4-3.1 1.2-4.2s1.9-1.6 3.2-1.6c1.2 0 2.1.4 2.9 1.2v-5.7h2.5v15.9h-2.3l-.1-1.2c-.8.9-1.8 1.4-3 1.4-1.3 0-2.4-.5-3.2-1.6-.8-.9-1.2-2.4-1.2-4.2zm2.5.2c0 1.1.2 2 .7 2.7.4.6 1.1 1 1.9 1 1 0 1.8-.5 2.3-1.4v-4.8c-.5-.9-1.2-1.3-2.2-1.3-.8 0-1.4.3-1.9 1-.6.6-.8 1.5-.8 2.8z"
  }), react_1["default"].createElement("path", {
    d: "m139.4 35.3h-5.8l-1.2 3.5h-2.7l5.7-15.1h2.4l5.7 15.1h-2.7zm-5.1-2.1h4.4l-2.2-6.3z"
  }), react_1["default"].createElement("path", {
    d: "m147.7 33.2v5.6h-2.6v-15.1h5.8c1.7 0 3 .4 4 1.3s1.5 2 1.5 3.5-.5 2.6-1.5 3.5-2.3 1.2-4.1 1.2zm0-2.1h3.2c.9 0 1.6-.2 2.1-.7.5-.4.7-1.1.7-1.9s-.2-1.5-.7-2-1.2-.7-2.1-.8h-3.2z"
  }), react_1["default"].createElement("path", {
    d: "m163 32.3-1.7 1.8v4.7h-2.6v-15.1h2.6v7.1l1.5-1.8 4.4-5.3h3.2l-5.6 6.7 5.9 8.4h-3.1z"
  }))));
};

exports["default"] = AndroidDownload;